import angular from 'angular';
import _ from 'lodash';

const menuStoreFactory = ($rootScope, Dispatcher, StoreStates) => {
  'ngInject';

  const menuStore = {
    list: [],
    state: StoreStates.STORE_EMPY
  };

  const notifyMenuChange = () => $rootScope.$broadcast('MENU_UPDATE');

  const notifyMenuRefresh = () => $rootScope.$broadcast('MENU_REFRESH');

  const notifyMenuFail = () => $rootScope.$broadcast('MENU_FAIL');

  const notifySaveMenu = () => $rootScope.$broadcast('SAVEMENU');

  const notifySaveMenuFail = () => $rootScope.$broadcast('SAVEMENU_FAIL');

  const deleteMenu = (menuId) => {
    const menuIndex = _.findIndex(menuStore.list, {
      id: menuId
    });

    if (menuIndex > -1) {
      menuStore.list.splice(menuIndex, 1);
    }
  };

  const setMenuProducts = (menuId, productIds) => {
    const menu = _.find(menuStore.list, {
      id: menuId
    });

    if (menu) {
      menu.products = productIds;
    }
  };

  const addProductToMenu = (menuId, productId) => {
    const menu = _.find(menuStore.list, {
      id: menuId
    });

    if (menu) {
      menu.products.push(productId);
    }
  };

  const removeProductFromMenu = (menuId, productId) => {
    const menu = _.find(menuStore.list, {
      id: menuId
    });

    if (menu) {
      const productIndex = menu.products.findIndex(selectedProduct => selectedProduct.id == productId);
      if (productIndex > -1) {
        menu.products.splice(productIndex, 1);
      }
    }
  };

  const saveMenuActivation = (menuId, active) => {
    const menu = _.find(menuStore.list, {
      id: menuId
    });

    if (active) {
      menuStore.list = _.map(menuStore.list, item => {
        item.active = false; // eslint-disable-line
        return item;
      });
    }

    if (menu) {
      menu.active = active;
    }
  };

  Dispatcher.register(action => {
    switch (action.actionType) {
      case 'MENU_LOAD_START':
        menuStore.list = [];
        menuStore.state = action.state;
        break;
      case 'MENU_LOAD_FAIL':
        menuStore.list = [];
        menuStore.state = action.state;
        notifyMenuFail();
        break;
      case 'MENU_LOAD':
        menuStore.list = action.data.menus;
        menuStore.state = action.state;
        notifyMenuChange();
        break;
      case 'SAVEMENU_CREATED':
        menuStore.list.push(action.data.menu);
        menuStore.state = action.state;
        notifyMenuChange();
        notifyMenuRefresh();
        notifySaveMenu();
        break;
      case 'SAVEMENU_EDIT':
        menuStore.state = action.state;
        const indexMenu = _.findIndex(menuStore.list, ['id', action.data.menuId]);
        if (indexMenu >= 0) {
          _.forEach(action.data.menu, (attr, name) => {
            menuStore.list[indexMenu][name] = attr;
          });
        }
        notifySaveMenu();
        break;
      case 'SAVEMENU_DELETED':
        deleteMenu(action.data.menuId);
        menuStore.state = action.state;
        notifySaveMenu();
        notifyMenuChange();
        break;
      case 'SAVEMENU_PRODUCTS_ASSIGNED':
        setMenuProducts(action.data.menuId, action.data.productIds);
        menuStore.state = action.state;
        //notifyMenuChange();
        notifyMenuRefresh();
        notifySaveMenu();
        break;
      case 'SAVEMENU_PRODUCT_ADDED':
        addProductToMenu(action.data.menuId, action.data.productId);
        menuStore.state = action.state;
        notifyMenuChange();
        break;
      case 'SAVEMENU_PRODUCT_DELETED':
        removeProductFromMenu(action.data.menuId, action.data.productId);
        menuStore.state = action.state;
        notifyMenuChange();
        notifyMenuRefresh();
        break;
      case 'SAVEMENU_ENABLED':
        saveMenuActivation(action.data.menuId, true);
        menuStore.state = action.state;
        // notifySaveMenu();
        notifyMenuChange();
        break;
      case 'SAVEMENU_DISABLED':
        saveMenuActivation(action.data.menuId, false);
        menuStore.state = action.state;
        notifySaveMenu();
        notifyMenuChange();
        break;
      case 'SAVEMENU_START':
        menuStore.state = action.state;
        break;
      case 'SAVEMENU_FAIL':
        menuStore.state = action.state;
        notifySaveMenuFail();
        break;
      case 'GLOBAL_CLEAN':
        menuStore.state = StoreStates.STORE_EMPY;
        menuStore.list = [];
        break;
      default:
        break;
    }
  });

  const store = {
    getMenuStoreState: () => menuStore.state,
    getMenus: () => angular.copy(menuStore.list),
    getMenusByProduct: productId => angular.copy(_.filter(menuStore.list, menu => menu.products.indexOf(productId) > -1)),
    getMenu: menuId => angular.copy(_.find(menuStore.list, {
      id: menuId
    })),
    forceExpired: () => {
      menuStore.state = StoreStates.STORE_EXPIRED;
    }
  };

  return store;
};

export default menuStoreFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/stores/menu.store.factory.js
 **/